import { render, staticRenderFns } from "./degree.vue?vue&type=template&id=24ee8f68&"
import script from "./degree.vue?vue&type=script&lang=js&"
export * from "./degree.vue?vue&type=script&lang=js&"
import style0 from "./degree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports